import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const SUPPORTED_UNITS_SCHEMA = order.shared.versions.v1.schemas.SUPPORTED_UNITS_SCHEMA;

export type SUPPORTED_UNITS = z.infer<typeof SUPPORTED_UNITS_SCHEMA>;

export const AUTOMATIC_SUPPORTED_UNITS_SCHEMA = SUPPORTED_UNITS_SCHEMA.extract(['TON', 'TRANSPORT']);
export type AUTOMATIC_SUPPORTED_UNITS = z.infer<typeof AUTOMATIC_SUPPORTED_UNITS_SCHEMA>;

export const ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA = SUPPORTED_UNITS_SCHEMA.extract(['TON', 'TRANSPORT', 'PIECE']);
export type ADDITIONAL_SERVICE_SUPPORTED_UNITS = z.infer<typeof ADDITIONAL_SERVICE_SUPPORTED_UNITS_SCHEMA>;
